import script from "./GSearch.vue?vue&type=script&lang=ts&setup=true"
export * from "./GSearch.vue?vue&type=script&lang=ts&setup=true"

import "./GSearch.vue?vue&type=style&index=0&id=0d8eeb0b&lang=css"

const __exports__ = script;

export default __exports__